module.exports = __webpack_public_path__ + "img/ic_trackorder.2e1a0ed4.svg";